import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Sectors() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/page-content/sectors").then(({ data }) => setContent(data));
  }, []);

  if (!content) {
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Yükleniyor...</div>;
  }

  const sectors = content.sectors || [];

  return (
    <div data-testid="sectors-page">
      <section className="bg-[#0A2540] text-white py-24" data-testid="sectors-hero">
        <div className="max-w-7xl mx-auto px-4 lg:px-12">
          <div className="text-xs uppercase tracking-[0.25em] text-[#0066FF] font-semibold mb-3">
            {content.hero_eyebrow}
          </div>
          <h1 className="heading-font text-4xl md:text-5xl lg:text-6xl max-w-4xl leading-[1.05]">
            <span className="text-[#0066FF]">{content.hero_title_part1}</span> {content.hero_title_part2}
          </h1>
          <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed whitespace-pre-line">
            {content.hero_subtitle}
          </p>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 lg:px-12">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-slate-200">
            {sectors.map((s, i) => (
              <div
                key={i}
                className="bg-white aspect-square flex items-center justify-center text-center p-6 hover:bg-[#0066FF] hover:text-white transition-colors group"
                data-testid={`sector-card-${i}`}
              >
                <div>
                  <div className="text-[10px] tracking-[0.25em] uppercase text-slate-400 group-hover:text-white/70 mb-2">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="heading-font text-base md:text-lg text-[#0A2540] group-hover:text-white">
                    {s}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
